const S = "/assets/marketing/v2";

export const CORE_MODULES = [
  {
    slug: "on-muhasebe",
    href: "/sayfa/on-muhasebe",
    img: `${S}/web-kasa-banka.webp`,
    plans: ["free", "plus", "esnaf", "pro"],
    coverage: { tr: "Tüm paketlerde", en: "Included in all plans" },
    title: { tr: "Kasa, Kart ve Cari Hesaplar", en: "Cash, Card and Current Accounts" },
    desc: {
      tr: "Para hareketi, müşteri/cari kayıtları ve ekstre paylaşımı tek finans ekranında.",
      en: "Money movement, customer/current records and statement sharing on one screen.",
    },
    alt: { tr: "Parasyo kasa ve banka ekranı", en: "Parasyo cash and bank screen" },
  },
  {
    slug: "gelir-gider-takibi",
    href: "/sayfa/gelir-gider-takibi",
    img: `${S}/web-giderler.webp`,
    plans: ["free", "plus", "esnaf", "pro"],
    coverage: { tr: "Tüm paketlerde", en: "Included in all plans" },
    title: { tr: "Gelir-Gider ve Bütçe", en: "Income-Expense and Budgets" },
    desc: {
      tr: "Kategori bazlı takip, tekrarlayan işlemler, bütçeler ve fiş görseli okuma.",
      en: "Category tracking, recurring transactions, budgets and receipt scanning.",
    },
    alt: { tr: "Parasyo gelir gider ekranı", en: "Parasyo income and expense screen" },
  },
  {
    slug: "stok-yonetimi",
    href: "/sayfa/stok-yonetimi",
    img: `${S}/web-stok.webp`,
    plans: ["free", "plus", "esnaf", "pro"],
    coverage: { tr: "Tüm paketlerde", en: "Included in all plans" },
    title: { tr: "Stok ve Depo", en: "Inventory and Warehouses" },
    desc: {
      tr: "Ürün kartları, depolar, hareket geçmişi ve kritik stok uyarıları.",
      en: "Product cards, warehouses, movement history and low-stock alerts.",
    },
    alt: { tr: "Parasyo stok yönetimi ekranı", en: "Parasyo inventory screen" },
  },
  {
    slug: "teklif-yonetimi",
    href: "/sayfa/teklif-yonetimi",
    img: `${S}/web-teklifler.webp`,
    plans: ["free", "plus", "esnaf", "pro"],
    coverage: { tr: "Tüm paketlerde", en: "Included in all plans" },
    title: { tr: "Fatura, Teklif ve Sipariş", en: "Invoices, Proposals and Orders" },
    desc: {
      tr: "Fatura kaydı, teklif onayı, siparişe dönüşüm ve ödeme durumu takibi.",
      en: "Invoice records, proposal approvals, order conversion and payment tracking.",
    },
    alt: { tr: "Parasyo teklif yönetimi ekranı", en: "Parasyo proposal management screen" },
  },
  {
    slug: "canli-destek",
    href: "/sayfa/canli-destek",
    img: `${S}/web-bugun.webp`,
    plans: ["free", "plus", "esnaf", "pro"],
    coverage: { tr: "Tüm paketlerde", en: "Included in all plans" },
    title: { tr: "Destek, Yedekleme ve Güvenlik", en: "Support, Backup and Security" },
    desc: {
      tr: "Canlı destek, otomatik bulut yedekleme ve güvenli paylaşım her pakette.",
      en: "Live support, automatic cloud backup and secure sharing on every plan.",
    },
    alt: { tr: "Parasyo destek ve güvenlik ekranı", en: "Parasyo support and security screen" },
  },
];

export const PACKAGE_FEATURES = [
  {
    slug: "home-plus",
    href: "/home-plus",
    img: `${S}/web-homeplus-ozet.webp`,
    plans: ["plus"],
    coverage: { tr: "Plus ile dahil", en: "Included with Plus" },
    title: { tr: "Home+ Ev ve Aile Yönetimi", en: "Home+ Home and Family Management" },
    desc: {
      tr: "Görev çarkı, ortak kasa, GSM taahhüdü, seans paketleri, yemek & kalori, araç ve evcil hayvan takibi — evin tamamı.",
      en: "Chore wheel, shared wallet, GSM commitments, session packages, meals & calories, vehicle and pet tracking — the whole home.",
    },
    alt: { tr: "Home+ özet ekranı", en: "Home+ overview screen" },
  },
  {
    slug: "cek-senet",
    href: "/sayfa/on-muhasebe",
    img: `${S}/web-cek-senet.webp`,
    plans: ["plus", "pro"],
    coverage: { tr: "Plus / Pro", en: "Plus / Pro" },
    title: { tr: "Çek / Senet Takibi", en: "Check / Note Tracking" },
    desc: {
      tr: "Hangi çek ne zaman ödenecek, vadesi geçen var mı; tek ekranda görürsün.",
      en: "Which check is due when, and whether anything is overdue; you see it on one screen.",
    },
    alt: { tr: "Çek / Senet Takibi — Hangi çek ne zaman ödenecek, vadesi geçen var mı; tek ekranda görürsün.", en: "Check / Note Tracking — Which check is due when, and whether anything is overdue; you see it on one screen." },
  },
  {
    slug: "proje-yonetimi",
    href: "/sayfa/gelir-gider-takibi",
    img: `${S}/web-proje-yonetimi.webp`,
    plans: ["pro"],
    coverage: { tr: "Pro", en: "Pro" },
    title: { tr: "Proje Yönetimi", en: "Project Management" },
    desc: {
      tr: "İşler hangi aşamada, teslime kaç gün kaldı; proje panosu söylüyor.",
      en: "What stage each job is at and how many days to delivery; the project board tells you.",
    },
    alt: { tr: "Proje Yönetimi — İşler hangi aşamada, teslime kaç gün kaldı; proje panosu söylüyor.", en: "Project Management — What stage each job is at and how many days to delivery; the project board tells you." },
  },
  {
    slug: "ik-temel",
    href: "/sayfa/insan-kaynaklari",
    img: `${S}/web-ik-plus.webp`,
    plans: ["pro"],
    coverage: { tr: "Pro", en: "Pro" },
    title: { tr: "İK ve Personel Yönetimi", en: "HR and Personnel Management" },
    desc: {
      tr: "Personel kayıtları, temel İK süreçleri ve ekip görünümü Pro pakette.",
      en: "Personnel records, core HR processes and team visibility in Pro.",
    },
    alt: { tr: "Parasyo İK ekranı", en: "Parasyo HR screen" },
  },
  {
    slug: "tedarikci-yonetimi",
    href: "/sayfa/on-muhasebe",
    img: `${S}/web-tedarikciler.webp`,
    plans: ["pro"],
    coverage: { tr: "Pro", en: "Pro" },
    title: { tr: "Tedarikçi Yönetimi", en: "Supplier Management" },
    desc: {
      tr: "Hangi tedarikçiye ne kadar borcun kaldığı kuruş kuruş belli.",
      en: "Exactly how much you owe each supplier, down to the penny.",
    },
    alt: { tr: "Tedarikçi Yönetimi — Hangi tedarikçiye ne kadar borcun kaldığı kuruş kuruş belli.", en: "Supplier Management — Exactly how much you owe each supplier, down to the penny." },
  },
  {
    slug: "alis-faturalari",
    href: "/sayfa/gelir-gider-takibi",
    img: `${S}/web-alis-faturalari.webp`,
    plans: ["pro"],
    coverage: { tr: "Pro", en: "Pro" },
    title: { tr: "Alış Faturaları", en: "Purchase Invoices" },
    desc: {
      tr: "Gider faturalarını KDV'siyle kaydet, ödenmeyeni gözden kaçırma.",
      en: "Record expense invoices with VAT, never miss an unpaid one.",
    },
    alt: { tr: "Alış Faturaları — Gider faturalarını KDV'siyle kaydet, ödenmeyeni gözden kaçırma.", en: "Purchase Invoices — Record expense invoices with VAT, never miss an unpaid one." },
  },
  {
    slug: "rol-yetki-coklu-sirket",
    href: "/sayfa/canli-destek",
    img: `${S}/web-ozet.webp`,
    plans: ["pro"],
    coverage: { tr: "Pro", en: "Pro" },
    title: { tr: "Rol, Yetki ve Çoklu Şirket", en: "Roles, Permissions and Multi-Company" },
    desc: {
      tr: "15 özel rol, 10 kullanıcı ve 3 şirketle ekip yönetimi.",
      en: "Team management with 15 custom roles, 10 users and 3 companies.",
    },
    alt: { tr: "Pro panel ekranı", en: "Pro panel screen" },
  },
  {
    slug: "gsm-taahhudu",
    phone: true,
    href: "/home-plus",
    img: "/assets/marketing/homeplus/mobil-gsm-taahhudu.webp",
    plans: ["plus"],
    coverage: { tr: "Plus ile dahil", en: "Included with Plus" },
    title: { tr: "İnternet & GSM Taahhüdü", en: "Internet & GSM Commitment" },
    desc: {
      tr: "Taahhüt bitişi, kalan ay ve kalan ödeme; bitişe 30, 15 ve 7 gün kala uyarı.",
      en: "Contract expiry, remaining months and payments; alerts 30, 15 and 7 days ahead.",
    },
    alt: { tr: "Home+ GSM taahhüt takip ekranı", en: "Home+ GSM commitment screen" },
  },
  {
    slug: "seans-paketleri",
    phone: true,
    href: "/home-plus",
    img: "/assets/marketing/homeplus/mobil-seans-paketleri.webp",
    plans: ["plus"],
    coverage: { tr: "Plus ile dahil", en: "Included with Plus" },
    title: { tr: "Ders & Seans Paketleri", en: "Lesson & Session Packages" },
    desc: {
      tr: "Kalan seans, ödenen/kalan borç ve seans başı maliyet; 2 seans kalınca uyarı.",
      en: "Remaining sessions, paid/remaining balance and per-session cost; alert when 2 sessions are left.",
    },
    alt: { tr: "Home+ seans paketi ekranı", en: "Home+ session package screen" },
  },
  {
    slug: "yemek-kalori",
    phone: true,
    href: "/home-plus",
    img: "/assets/marketing/homeplus/mobil-kalori.webp",
    plans: ["plus"],
    coverage: { tr: "Plus ile dahil", en: "Included with Plus" },
    title: { tr: "Yemek & Kalori Takibi", en: "Meals & Calorie Tracking" },
    desc: {
      tr: "Hazır Türk yemekleri tablosuyla günlük hedef ve makro takibi; kayıtlar yalnızca size görünür.",
      en: "Daily target and macro tracking with a ready Turkish food table; records visible only to you.",
    },
    alt: { tr: "Home+ yemek ve kalori ekranı", en: "Home+ meal and calorie screen" },
  },
  {
    slug: "arac-garaj",
    phone: true,
    href: "/home-plus",
    img: "/assets/marketing/homeplus/mobil-arac-garaj.webp",
    plans: ["plus"],
    coverage: { tr: "Plus ile dahil", en: "Included with Plus" },
    title: { tr: "Araç & Garaj", en: "Vehicle & Garage" },
    desc: {
      tr: "Km başı maliyet, ortalama tüketim; muayene ve sigorta tarihleri 15 gün önceden hatırlatılır.",
      en: "Cost per km and average consumption; inspection and insurance dates flagged 15 days ahead.",
    },
    alt: { tr: "Home+ araç ve garaj ekranı", en: "Home+ vehicle and garage screen" },
  },
  {
    slug: "evcil-hayvan",
    phone: true,
    href: "/home-plus",
    img: "/assets/marketing/homeplus/mobil-evcil-hayvan.webp",
    plans: ["plus"],
    coverage: { tr: "Plus ile dahil", en: "Included with Plus" },
    title: { tr: "Evcil Hayvan Takibi", en: "Pet Tracking" },
    desc: {
      tr: "Aşı takvimi, veteriner masrafları ve \"mama ne zaman bitecek\" tahmini.",
      en: "Vaccination schedule, vet expenses and a \"when will the food run out\" estimate.",
    },
    alt: { tr: "Home+ evcil hayvan ekranı", en: "Home+ pet care screen" },
  },
  {
    slug: "hizli-satis-pos",
    href: "/pos",
    img: `${S}/web-pos.webp`,
    plans: ["esnaf", "pro"],
    coverage: { tr: "Premium & Pro'ya dahil", en: "Included in Premium & Pro" },
    title: { tr: "Hızlı Satış (POS)", en: "Fast Sale (POS)" },
    desc: {
      tr: "Barkodlu hızlı satış, veresiye, 80 mm termal fiş, Z raporu ve kasa açılış-kapanış takibi.",
      en: "Barcode fast sale, tabs, 80 mm thermal receipts, Z reports and register open/close tracking.",
    },
    alt: { tr: "Hızlı Satış POS ekranı", en: "Fast Sale POS screen" },
  },
  {
    slug: "crm",
    href: "/paket/parasyo-pro",
    img: "/assets/eklentiler/crm-01-satis-hatti.webp",
    plans: ["pro"],
    coverage: { tr: "Pro'ya dahil", en: "Included in Pro" },
    title: { tr: "Detaylı CRM", en: "Advanced CRM" },
    desc: {
      tr: "360° müşteri kartı, satış hattı (Kanban), aktivite kaydı ve ekip performans raporları.",
      en: "360° customer cards, sales pipeline (Kanban), activity log and team performance reports.",
    },
    alt: { tr: "CRM satış hattı ekranı", en: "CRM pipeline screen" },
  },
  {
    slug: "dokuman-yonetimi",
    href: "/paket/parasyo-pro",
    img: "/assets/eklentiler/dms-01-belgeler.webp",
    plans: ["pro"],
    coverage: { tr: "Pro'ya dahil", en: "Included in Pro" },
    title: { tr: "Doküman Yönetimi (DMS)", en: "Document Management (DMS)" },
    desc: {
      tr: "Klasör ağacı, akıllı etiketler, sürüm geçmişi ve bağlantı ile dış paylaşım.",
      en: "Folder tree, smart tags, version history and external sharing via link.",
    },
    alt: { tr: "Doküman yönetimi ekranı", en: "Document management screen" },
  },
  {
    slug: "ik-plus",
    href: "/paket/parasyo-pro",
    img: "/assets/eklentiler/ikplus-01-personel.webp",
    plans: ["pro"],
    coverage: { tr: "Pro'ya dahil", en: "Included in Pro" },
    title: { tr: "İK+", en: "HR+" },
    desc: {
      tr: "İzin onay akışı, zimmet takibi, işe alım havuzu ve çalışan self-servis portalı.",
      en: "Leave approval flows, asset tracking, hiring pool and an employee self-service portal.",
    },
    alt: { tr: "İK+ personel ekranı", en: "HR+ employee screen" },
  },
  {
    slug: "pdks",
    href: "/paket/parasyo-pro",
    img: "/assets/eklentiler/pdks-01-canli.webp",
    plans: ["pro"],
    coverage: { tr: "Pro'ya dahil", en: "Included in Pro" },
    title: { tr: "PDKS · Puantaj", en: "Time & Attendance" },
    desc: {
      tr: "QR ile giriş-çıkış, GPS doğrulama, canlı liste ve aylık puantajın bordroya akışı.",
      en: "QR clock-in/out, GPS verification, live list and monthly timesheets flowing into payroll.",
    },
    alt: { tr: "PDKS canlı giriş-çıkış ekranı", en: "Live attendance screen" },
  },
];

export const PLAN_OPTIONS = [
  { id: "all", label: { tr: "Tümü", en: "All" } },
  { id: "free", label: { tr: "ParasyoFree", en: "ParasyoFree" } },
  { id: "plus", label: { tr: "Plus", en: "Plus" } },
  { id: "esnaf", label: { tr: "Premium", en: "Premium" } },
  { id: "pro", label: { tr: "Pro", en: "Pro" } },
];
